import React from "react";
import {
  t,
  HEADING1,
  AWARD_LI1,
  AWARD_LI2,
  AWARD_LI3,
  AWARD_LI4,
  AWARD_LI5,
  AWARD_LI6,
  AWARD_LI7,
  AWARD_LI8,
  AWARD_LI9,
  AWARD_LI10,
  AWARD_LI11,
  AWARD_LI12,
  AWARD_LI13,
  AWARD_LI14,
  AWARD_LI15,
  AWARD_LI16,
  AWARD_LI17,
  AWARD_LI18,
  AWARD_LI19,
  AWARD_LI20,
  AWARD_LI21,
  AWARD_LI22,
  AWARD_LI23,
  AWARD_LI24,
  AWARD_LI25,
  AWARD_LI26,
  AWARD_LI27,
  AWARD_LI28,
  AWARD_LI29,
  AWARD_LI30,
  AWARD_LI31,
  AWARD_LI32,
  AWARD_LI33,
  AWARD_LI34,
  AWARD_LI35,
  AWARD_LI36,
  AWARD_LI37,
  AWARD_LI38,
  AWARD_LI39,
  AWARD_LI40,
  AWARD_LI41,
  AWARD_LI42,
  AWARD_LI43,
  AWARD_LI44,
  AWARD_LI45,
  AWARD_LI46,
  AWARD_LI47,
  AWARD_LI48,
  AWARD_LI49,
  AWARD_LI50,
  AWARD_LI51,
  AWARD_LI52,
  AWARD_LI53,
  AWARD_LI54,
  AWARD_LI55,
  AWARD_LI56,
  AWARD_LI57,
  AWARD_LI58,
  AWARD_LI59,
  AWARD_LI60,
  AWARD_LI61,
  AWARD_LI62,
  AWARD_LI63,
  AWARD_LI64,
  AWARD_LI65,
  AWARD_LI66,
  AWARD_LI67,
  AWARD_LI68,
  AWARD_LI69,
  AWARD_LI70,
  AWARD_LI71,
  AWARD_LI72,
  AWARD_LI73,
  AWARD_LI74,
  AWARD_LI75,
  AWARD_LI76,
  AWARD_LI77,
  AWARD_LI78,
  AWARD_LI79,
  AWARD_LI80,
  AWARD_LI81,
  AWARD_LI82,
  AWARD_LI83,
  AWARD_LI84,
  AWARD_LI85,
  AWARD_LI86,
  AWARD_LI87,
  AWARD_LI88,
  AWARD_LI89,
  AWARD_LI90,
  AWARD_LI91,
  AWARD_LI92,
  AWARD_LI93,
  AWARD_LI94,
  AWARD_LI95,
  AWARD_LI96,
  AWARD_LI97,
  AWARD_LI98,
  AWARD_LI99,
  AWARD_LI100,
  AWARD_LI101,
  AWARD_LI102,
  AWARD_LI103,
  AWARD_LI104,
  AWARD_LI105,
  AWARD_LI106,
  AWARD_LI107,
  AWARD_LI108,
  AWARD_LI109,
  AWARD_LI110,
  AWARD_LI111,
  AWARD_LI112,
  AWARD_LI113,
  AWARD_LI114,
  AWARD_LI115,
  AWARD_LI116,
  AWARD_LI117,
  AWARD_LI118,
  AWARD_LI119,
  AWARD_LI120,
  AWARD_LI121,
  AWARD_LI122,
  AWARD_LI123,
  AWARD_LI124,
  AWARD_LI125,
  AWARD_LI126,
  AWARD_LI127,
  AWARD_LI128,
  AWARD_LI129,
  AWARD_LI130,
  AWARD_LI131,
  AWARD_LI132,
  AWARD_LI133,
  AWARD_LI134,
  AWARD_LI135,
  AWARD_LI136,
  AWARD_LI137,
  AWARD_LI138,
  AWARD_LI139,
  AWARD_LI140,
  AWARD_LI141,
  AWARD_LI142,
  AWARD_LI143,
  AWARD_LI144,
  AWARD_LI145,
  AWARD_LI146,
  AWARD_LI147,
  AWARD_LI148,
  AWARD_LI149,
  AWARD_LI150,
  AWARD_LI151,
  AWARD_LI152,
  AWARD_LI153,
  AWARD_LI154,
  AWARD_LI155,
  AWARD_LI156,
  AWARD_LI157,
  AWARD_LI158,
  AWARD_LI159,
  AWARD_LI160,
  AWARD_LI161,
  AWARD_LI162,
  AWARD_LI163,
  AWARD_LI164,
  AWARD_LI165,
  AWARD_LI166,
  AWARD_LI167,
  AWARD_LI168,
  AWARD_LI169,
  AWARD_LI170,
  AWARD_LI171,
  AWARD_LI172,
  AWARD_LI173,
  AWARD_LI174,
  AWARD_LI175,
  AWARD_LI176,
  AWARD_LI177,
  AWARD_LI178,
  AWARD_LI179,
  AWARD_LI180,
  AWARD_LI181,
  AWARD_LI182,
  AWARD_LI183,
  AWARD_LI184,
  AWARD_LI185,
  AWARD_LI186,
  AWARD_LI187,
  AWARD_LI188,
  AWARD_LI189,
  AWARD_LI190,
  AWARD_LI191,
  AWARD_LI192,
  AWARD_LI193,
  AWARD_LI194,
  AWARD_LI195,
  AWARD_LI196,
  AWARD_LI197,
  AWARD_LI198,
  AWARD_LI199,
  AWARD_LI200,
  AWARD_LI201,
  AWARD_LI202,
  AWARD_LI203,
  AWARD_LI204,
  AWARD_LI205,
  AWARD_LI206,
  AWARD_LI207,
  AWARD_LI208,
  AWARD_LI209,
  AWARD_LI210,
  AWARD_LI211,
  AWARD_LI212,
  AWARD_LI213,
  AWARD_LI214,
  AWARD_LI215,
  AWARD_LI216,
  AWARD_LI217,
  AWARD_LI218,
  AWARD_LI219,
  AWARD_LI220,
  AWARD_LI221,
  AWARD_LI222,
  AWARD_LI223,
  AWARD_LI224,
  AWARD_LI225,
  AWARD_LI226,
  AWARD_LI227,
  AWARD_LI228,
  AWARD_LI229,
  AWARD_LI230,
  AWARD_LI231,
  AWARD_LI232,
  AWARD_LI233,
  AWARD_LI234,
  AWARD_LI235,
  AWARD_LI236,
  AWARD_LI237,
  AWARD_LI238,
} from "../../translations/AboutUs/Awards";

function Awards() {
  return (
    <div
      style={{
        width: "80%",
        display: "flex",
        alignItems: "flex-start",
        justifyContent: "flex-start",
        flexDirection: "column",
        gap: 15,
        paddingRight: 10,
      }}
    >
      <div className="a-large" style={{ fontSize: 20, fontWeight: 600, textAlign: "left" }}>
        {t(HEADING1)}
      </div>
      <ul style={{ margin: 0, padding: 0, marginLeft: 20 }}>
        <li className="a-regular" style={{ fontWeight: 400 }}>{t(AWARD_LI1)}</li>
        <li className="a-regular" style={{ fontWeight: 400 }}>{t(AWARD_LI2)}</li>
        <li className="a-regular" style={{ fontWeight: 400 }}>{t(AWARD_LI3)}</li>
        <li className="a-regular" style={{ fontWeight: 400 }}>{t(AWARD_LI4)}</li>
        <li className="a-regular" style={{ fontWeight: 400 }}>{t(AWARD_LI5)}</li>
        <li className="a-regular" style={{ fontWeight: 400 }}>{t(AWARD_LI6)}</li>
        <li className="a-regular" style={{ fontWeight: 400 }}>{t(AWARD_LI7)}</li>
        <li className="a-regular" style={{ fontWeight: 400 }}>{t(AWARD_LI8)}</li>
        <li className="a-regular" style={{ fontWeight: 400 }}>{t(AWARD_LI9)}</li>
        <li className="a-regular" style={{ fontWeight: 400 }}>{t(AWARD_LI10)}</li>
        <li className="a-regular" style={{ fontWeight: 400 }}>{t(AWARD_LI11)}</li>
        <li className="a-regular" style={{ fontWeight: 400 }}>{t(AWARD_LI12)}</li>
        <li className="a-regular" style={{ fontWeight: 400 }}>{t(AWARD_LI13)}</li>
        <li className="a-regular" style={{ fontWeight: 400 }}>{t(AWARD_LI14)}</li>
        <li className="a-regular" style={{ fontWeight: 400 }}>{t(AWARD_LI15)}</li>
        <li className="a-regular" style={{ fontWeight: 400 }}>{t(AWARD_LI16)}</li>
        <li className="a-regular" style={{ fontWeight: 400 }}>{t(AWARD_LI17)}</li>
        <li className="a-regular" style={{ fontWeight: 400 }}>{t(AWARD_LI18)}</li>
        <li className="a-regular" style={{ fontWeight: 400 }}>{t(AWARD_LI19)}</li>
        <li className="a-regular" style={{ fontWeight: 400 }}>{t(AWARD_LI20)}</li>
        <li className="a-regular" style={{ fontWeight: 400 }}>{t(AWARD_LI21)}</li>
        <li className="a-regular" style={{ fontWeight: 400 }}>{t(AWARD_LI22)}</li>
        <li className="a-regular" style={{ fontWeight: 400 }}>{t(AWARD_LI23)}</li>
        <li className="a-regular" style={{ fontWeight: 400 }}>{t(AWARD_LI24)}</li>
        <li className="a-regular" style={{ fontWeight: 400 }}>{t(AWARD_LI25)}</li>
        <li className="a-regular" style={{ fontWeight: 400 }}>{t(AWARD_LI26)}</li>
        <li className="a-regular" style={{ fontWeight: 400 }}>{t(AWARD_LI27)}</li>
        <li className="a-regular" style={{ fontWeight: 400 }}>{t(AWARD_LI28)}</li>
        <li className="a-regular" style={{ fontWeight: 400 }}>{t(AWARD_LI29)}</li>
        <li className="a-regular" style={{ fontWeight: 400 }}>{t(AWARD_LI30)}</li>
        <li className="a-regular" style={{ fontWeight: 400 }}>{t(AWARD_LI31)}</li>
        <li className="a-regular" style={{ fontWeight: 400 }}>{t(AWARD_LI32)}</li>
        <li className="a-regular" style={{ fontWeight: 400 }}>{t(AWARD_LI33)}</li>
        <li className="a-regular" style={{ fontWeight: 400 }}>{t(AWARD_LI34)}</li>
        <li className="a-regular" style={{ fontWeight: 400 }}>{t(AWARD_LI35)}</li>
        <li className="a-regular" style={{ fontWeight: 400 }}>{t(AWARD_LI36)}</li>
        <li className="a-regular" style={{ fontWeight: 400 }}>{t(AWARD_LI37)}</li>
        <li className="a-regular" style={{ fontWeight: 400 }}>{t(AWARD_LI38)}</li>
        <li className="a-regular" style={{ fontWeight: 400 }}>{t(AWARD_LI39)}</li>
        <li className="a-regular" style={{ fontWeight: 400 }}>{t(AWARD_LI40)}</li>
        <li className="a-regular" style={{ fontWeight: 400 }}>{t(AWARD_LI41)}</li>
        <li className="a-regular" style={{ fontWeight: 400 }}>{t(AWARD_LI42)}</li>
        <li className="a-regular" style={{ fontWeight: 400 }}>{t(AWARD_LI43)}</li>
        <li className="a-regular" style={{ fontWeight: 400 }}>{t(AWARD_LI44)}</li>
        <li className="a-regular" style={{ fontWeight: 400 }}>{t(AWARD_LI45)}</li>
        <li className="a-regular" style={{ fontWeight: 400 }}>{t(AWARD_LI46)}</li>
        <li className="a-regular" style={{ fontWeight: 400 }}>{t(AWARD_LI47)}</li>
        <li className="a-regular" style={{ fontWeight: 400 }}>{t(AWARD_LI48)}</li>
        <li className="a-regular" style={{ fontWeight: 400 }}>{t(AWARD_LI49)}</li>
        <li className="a-regular" style={{ fontWeight: 400 }}>{t(AWARD_LI50)}</li>
        <li className="a-regular" style={{ fontWeight: 400 }}>{t(AWARD_LI51)}</li>
        <li className="a-regular" style={{ fontWeight: 400 }}>{t(AWARD_LI52)}</li>
        <li className="a-regular" style={{ fontWeight: 400 }}>{t(AWARD_LI53)}</li>
        <li className="a-regular" style={{ fontWeight: 400 }}>{t(AWARD_LI54)}</li>
        <li className="a-regular" style={{ fontWeight: 400 }}>{t(AWARD_LI55)}</li>
        <li className="a-regular" style={{ fontWeight: 400 }}>{t(AWARD_LI56)}</li>
        <li className="a-regular" style={{ fontWeight: 400 }}>{t(AWARD_LI57)}</li>
        <li className="a-regular" style={{ fontWeight: 400 }}>{t(AWARD_LI58)}</li>
        <li className="a-regular" style={{ fontWeight: 400 }}>{t(AWARD_LI59)}</li>
        <li className="a-regular" style={{ fontWeight: 400 }}>{t(AWARD_LI60)}</li>
        <li className="a-regular" style={{ fontWeight: 400 }}>{t(AWARD_LI61)}</li>
        <li className="a-regular" style={{ fontWeight: 400 }}>{t(AWARD_LI62)}</li>
        <li className="a-regular" style={{ fontWeight: 400 }}>{t(AWARD_LI63)}</li>
        <li className="a-regular" style={{ fontWeight: 400 }}>{t(AWARD_LI64)}</li>
        <li className="a-regular" style={{ fontWeight: 400 }}>{t(AWARD_LI65)}</li>
        <li className="a-regular" style={{ fontWeight: 400 }}>{t(AWARD_LI66)}</li>
        <li className="a-regular" style={{ fontWeight: 400 }}>{t(AWARD_LI67)}</li>
        <li className="a-regular" style={{ fontWeight: 400 }}>{t(AWARD_LI68)}</li>
        <li className="a-regular" style={{ fontWeight: 400 }}>{t(AWARD_LI69)}</li>
        <li className="a-regular" style={{ fontWeight: 400 }}>{t(AWARD_LI70)}</li>
        <li className="a-regular" style={{ fontWeight: 400 }}>{t(AWARD_LI71)}</li>
        <li className="a-regular" style={{ fontWeight: 400 }}>{t(AWARD_LI72)}</li>
        <li className="a-regular" style={{ fontWeight: 400 }}>{t(AWARD_LI73)}</li>
        <li className="a-regular" style={{ fontWeight: 400 }}>{t(AWARD_LI74)}</li>
        <li className="a-regular" style={{ fontWeight: 400 }}>{t(AWARD_LI75)}</li>
        <li className="a-regular" style={{ fontWeight: 400 }}>{t(AWARD_LI76)}</li>
        <li className="a-regular" style={{ fontWeight: 400 }}>{t(AWARD_LI77)}</li>
        <li className="a-regular" style={{ fontWeight: 400 }}>{t(AWARD_LI78)}</li>
        <li className="a-regular" style={{ fontWeight: 400 }}>{t(AWARD_LI79)}</li>
        <li className="a-regular" style={{ fontWeight: 400 }}>{t(AWARD_LI80)}</li>
        <li className="a-regular" style={{ fontWeight: 400 }}>{t(AWARD_LI81)}</li>
        <li className="a-regular" style={{ fontWeight: 400 }}>{t(AWARD_LI82)}</li>
        <li className="a-regular" style={{ fontWeight: 400 }}>{t(AWARD_LI83)}</li>
        <li className="a-regular" style={{ fontWeight: 400 }}>{t(AWARD_LI84)}</li>
        <li className="a-regular" style={{ fontWeight: 400 }}>{t(AWARD_LI85)}</li>
        <li className="a-regular" style={{ fontWeight: 400 }}>{t(AWARD_LI86)}</li>
        <li className="a-regular" style={{ fontWeight: 400 }}>{t(AWARD_LI87)}</li>
        <li className="a-regular" style={{ fontWeight: 400 }}>{t(AWARD_LI88)}</li>
        <li className="a-regular" style={{ fontWeight: 400 }}>{t(AWARD_LI89)}</li>
        <li className="a-regular" style={{ fontWeight: 400 }}>{t(AWARD_LI90)}</li>
        <li className="a-regular" style={{ fontWeight: 400 }}>{t(AWARD_LI91)}</li>
        <li className="a-regular" style={{ fontWeight: 400 }}>{t(AWARD_LI92)}</li>
        <li className="a-regular" style={{ fontWeight: 400 }}>{t(AWARD_LI93)}</li>
        <li className="a-regular" style={{ fontWeight: 400 }}>{t(AWARD_LI94)}</li>
        <li className="a-regular" style={{ fontWeight: 400 }}>{t(AWARD_LI95)}</li>
        <li className="a-regular" style={{ fontWeight: 400 }}>{t(AWARD_LI96)}</li>
        <li className="a-regular" style={{ fontWeight: 400 }}>{t(AWARD_LI97)}</li>
        <li className="a-regular" style={{ fontWeight: 400 }}>{t(AWARD_LI98)}</li>
        <li className="a-regular" style={{ fontWeight: 400 }}>{t(AWARD_LI99)}</li>
        <li className="a-regular" style={{ fontWeight: 400 }}>{t(AWARD_LI100)}</li>
        <li className="a-regular" style={{ fontWeight: 400 }}>{t(AWARD_LI101)}</li>
        <li className="a-regular" style={{ fontWeight: 400 }}>{t(AWARD_LI102)}</li>
        <li className="a-regular" style={{ fontWeight: 400 }}>{t(AWARD_LI103)}</li>
        <li className="a-regular" style={{ fontWeight: 400 }}>{t(AWARD_LI104)}</li>
        <li className="a-regular" style={{ fontWeight: 400 }}>{t(AWARD_LI105)}</li>
        <li className="a-regular" style={{ fontWeight: 400 }}>{t(AWARD_LI106)}</li>
        <li className="a-regular" style={{ fontWeight: 400 }}>{t(AWARD_LI107)}</li>
        <li className="a-regular" style={{ fontWeight: 400 }}>{t(AWARD_LI108)}</li>
        <li className="a-regular" style={{ fontWeight: 400 }}>{t(AWARD_LI109)}</li>
        <li className="a-regular" style={{ fontWeight: 400 }}>{t(AWARD_LI110)}</li>
        <li className="a-regular" style={{ fontWeight: 400 }}>{t(AWARD_LI111)}</li>
        <li className="a-regular" style={{ fontWeight: 400 }}>{t(AWARD_LI112)}</li>
        <li className="a-regular" style={{ fontWeight: 400 }}>{t(AWARD_LI113)}</li>
        <li className="a-regular" style={{ fontWeight: 400 }}>{t(AWARD_LI114)}</li>
        <li className="a-regular" style={{ fontWeight: 400 }}>{t(AWARD_LI115)}</li>
        <li className="a-regular" style={{ fontWeight: 400 }}>{t(AWARD_LI116)}</li>
        <li className="a-regular" style={{ fontWeight: 400 }}>{t(AWARD_LI117)}</li>
        <li className="a-regular" style={{ fontWeight: 400 }}>{t(AWARD_LI118)}</li>
        <li className="a-regular" style={{ fontWeight: 400 }}>{t(AWARD_LI119)}</li>
        <li className="a-regular" style={{ fontWeight: 400 }}>{t(AWARD_LI120)}</li>
        <li className="a-regular" style={{ fontWeight: 400 }}>{t(AWARD_LI121)}</li>
        <li className="a-regular" style={{ fontWeight: 400 }}>{t(AWARD_LI122)}</li>
        <li className="a-regular" style={{ fontWeight: 400 }}>{t(AWARD_LI123)}</li>
        <li className="a-regular" style={{ fontWeight: 400 }}>{t(AWARD_LI124)}</li>
        <li className="a-regular" style={{ fontWeight: 400 }}>{t(AWARD_LI125)}</li>
        <li className="a-regular" style={{ fontWeight: 400 }}>{t(AWARD_LI126)}</li>
        <li className="a-regular" style={{ fontWeight: 400 }}>{t(AWARD_LI127)}</li>
        <li className="a-regular" style={{ fontWeight: 400 }}>{t(AWARD_LI128)}</li>
        <li className="a-regular" style={{ fontWeight: 400 }}>{t(AWARD_LI129)}</li>
        <li className="a-regular" style={{ fontWeight: 400 }}>{t(AWARD_LI130)}</li>
        <li className="a-regular" style={{ fontWeight: 400 }}>{t(AWARD_LI131)}</li>
        <li className="a-regular" style={{ fontWeight: 400 }}>{t(AWARD_LI132)}</li>
        <li className="a-regular" style={{ fontWeight: 400 }}>{t(AWARD_LI133)}</li>
        <li className="a-regular" style={{ fontWeight: 400 }}>{t(AWARD_LI134)}</li>
        <li className="a-regular" style={{ fontWeight: 400 }}>{t(AWARD_LI135)}</li>
        <li className="a-regular" style={{ fontWeight: 400 }}>{t(AWARD_LI136)}</li>
        <li className="a-regular" style={{ fontWeight: 400 }}>{t(AWARD_LI137)}</li>
        <li className="a-regular" style={{ fontWeight: 400 }}>{t(AWARD_LI138)}</li>
        <li className="a-regular" style={{ fontWeight: 400 }}>{t(AWARD_LI139)}</li>
        <li className="a-regular" style={{ fontWeight: 400 }}>{t(AWARD_LI140)}</li>
        <li className="a-regular" style={{ fontWeight: 400 }}>{t(AWARD_LI141)}</li>
        <li className="a-regular" style={{ fontWeight: 400 }}>{t(AWARD_LI142)}</li>
        <li className="a-regular" style={{ fontWeight: 400 }}>{t(AWARD_LI143)}</li>
        <li className="a-regular" style={{ fontWeight: 400 }}>{t(AWARD_LI144)}</li>
        <li className="a-regular" style={{ fontWeight: 400 }}>{t(AWARD_LI145)}</li>
        <li className="a-regular" style={{ fontWeight: 400 }}>{t(AWARD_LI146)}</li>
        <li className="a-regular" style={{ fontWeight: 400 }}>{t(AWARD_LI147)}</li>
        <li className="a-regular" style={{ fontWeight: 400 }}>{t(AWARD_LI148)}</li>
        <li className="a-regular" style={{ fontWeight: 400 }}>{t(AWARD_LI149)}</li>
        <li className="a-regular" style={{ fontWeight: 400 }}>{t(AWARD_LI150)}</li>
        <li className="a-regular" style={{ fontWeight: 400 }}>{t(AWARD_LI151)}</li>
        <li className="a-regular" style={{ fontWeight: 400 }}>{t(AWARD_LI152)}</li>
        <li className="a-regular" style={{ fontWeight: 400 }}>{t(AWARD_LI153)}</li>
        <li className="a-regular" style={{ fontWeight: 400 }}>{t(AWARD_LI154)}</li>
        <li className="a-regular" style={{ fontWeight: 400 }}>{t(AWARD_LI155)}</li>
        <li className="a-regular" style={{ fontWeight: 400 }}>{t(AWARD_LI156)}</li>
        <li className="a-regular" style={{ fontWeight: 400 }}>{t(AWARD_LI157)}</li>
        <li className="a-regular" style={{ fontWeight: 400 }}>{t(AWARD_LI158)}</li>
        <li className="a-regular" style={{ fontWeight: 400 }}>{t(AWARD_LI159)}</li>
        <li className="a-regular" style={{ fontWeight: 400 }}>{t(AWARD_LI160)}</li>
        <li className="a-regular" style={{ fontWeight: 400 }}>{t(AWARD_LI161)}</li>
        <li className="a-regular" style={{ fontWeight: 400 }}>{t(AWARD_LI162)}</li>
        <li className="a-regular" style={{ fontWeight: 400 }}>{t(AWARD_LI163)}</li>
        <li className="a-regular" style={{ fontWeight: 400 }}>{t(AWARD_LI164)}</li>
        <li className="a-regular" style={{ fontWeight: 400 }}>{t(AWARD_LI165)}</li>
        <li className="a-regular" style={{ fontWeight: 400 }}>{t(AWARD_LI166)}</li>
        <li className="a-regular" style={{ fontWeight: 400 }}>{t(AWARD_LI167)}</li>
        <li className="a-regular" style={{ fontWeight: 400 }}>{t(AWARD_LI168)}</li>
        <li className="a-regular" style={{ fontWeight: 400 }}>{t(AWARD_LI169)}</li>
        <li className="a-regular" style={{ fontWeight: 400 }}>{t(AWARD_LI170)}</li>
        <li className="a-regular" style={{ fontWeight: 400 }}>{t(AWARD_LI171)}</li>
        <li className="a-regular" style={{ fontWeight: 400 }}>{t(AWARD_LI172)}</li>
        <li className="a-regular" style={{ fontWeight: 400 }}>{t(AWARD_LI173)}</li>
        <li className="a-regular" style={{ fontWeight: 400 }}>{t(AWARD_LI174)}</li>
        <li className="a-regular" style={{ fontWeight: 400 }}>{t(AWARD_LI175)}</li>
        <li className="a-regular" style={{ fontWeight: 400 }}>{t(AWARD_LI176)}</li>
        <li className="a-regular" style={{ fontWeight: 400 }}>{t(AWARD_LI177)}</li>
        <li className="a-regular" style={{ fontWeight: 400 }}>{t(AWARD_LI178)}</li>
        <li className="a-regular" style={{ fontWeight: 400 }}>{t(AWARD_LI179)}</li>
        <li className="a-regular" style={{ fontWeight: 400 }}>{t(AWARD_LI180)}</li>
        <li className="a-regular" style={{ fontWeight: 400 }}>{t(AWARD_LI181)}</li>
        <li className="a-regular" style={{ fontWeight: 400 }}>{t(AWARD_LI182)}</li>
        <li className="a-regular" style={{ fontWeight: 400 }}>{t(AWARD_LI183)}</li>
        <li className="a-regular" style={{ fontWeight: 400 }}>{t(AWARD_LI184)}</li>
        <li className="a-regular" style={{ fontWeight: 400 }}>{t(AWARD_LI185)}</li>
        <li className="a-regular" style={{ fontWeight: 400 }}>{t(AWARD_LI186)}</li>
        <li className="a-regular" style={{ fontWeight: 400 }}>{t(AWARD_LI187)}</li>
        <li className="a-regular" style={{ fontWeight: 400 }}>{t(AWARD_LI189)}</li>
        <li className="a-regular" style={{ fontWeight: 400 }}>{t(AWARD_LI190)}</li>
        <li className="a-regular" style={{ fontWeight: 400 }}>{t(AWARD_LI191)}</li>
        <li className="a-regular" style={{ fontWeight: 400 }}>{t(AWARD_LI192)}</li>
        <li className="a-regular" style={{ fontWeight: 400 }}>{t(AWARD_LI193)}</li>
        <li className="a-regular" style={{ fontWeight: 400 }}>{t(AWARD_LI194)}</li>
        <li className="a-regular" style={{ fontWeight: 400 }}>{t(AWARD_LI195)}</li>
        <li className="a-regular" style={{ fontWeight: 400 }}>{t(AWARD_LI196)}</li>
        <li className="a-regular" style={{ fontWeight: 400 }}>{t(AWARD_LI197)}</li>
        <li className="a-regular" style={{ fontWeight: 400 }}>{t(AWARD_LI198)}</li>
        <li className="a-regular" style={{ fontWeight: 400 }}>{t(AWARD_LI199)}</li>
        <li className="a-regular" style={{ fontWeight: 400 }}>{t(AWARD_LI200)}</li>
        <li className="a-regular" style={{ fontWeight: 400 }}>{t(AWARD_LI201)}</li>
        <li className="a-regular" style={{ fontWeight: 400 }}>{t(AWARD_LI202)}</li>
        <li className="a-regular" style={{ fontWeight: 400 }}>{t(AWARD_LI203)}</li>
        <li className="a-regular" style={{ fontWeight: 400 }}>{t(AWARD_LI204)}</li>
        <li className="a-regular" style={{ fontWeight: 400 }}>{t(AWARD_LI205)}</li>
        <li className="a-regular" style={{ fontWeight: 400 }}>{t(AWARD_LI206)}</li>
        <li className="a-regular" style={{ fontWeight: 400 }}>{t(AWARD_LI207)}</li>
        <li className="a-regular" style={{ fontWeight: 400 }}>{t(AWARD_LI208)}</li>
        <li className="a-regular" style={{ fontWeight: 400 }}>{t(AWARD_LI209)}</li>
        <li className="a-regular" style={{ fontWeight: 400 }}>{t(AWARD_LI210)}</li>
        <li className="a-regular" style={{ fontWeight: 400 }}>{t(AWARD_LI211)}</li>
        <li className="a-regular" style={{ fontWeight: 400 }}>{t(AWARD_LI212)}</li>
        <li className="a-regular" style={{ fontWeight: 400 }}>{t(AWARD_LI213)}</li>
        <li className="a-regular" style={{ fontWeight: 400 }}>{t(AWARD_LI214)}</li>
        <li className="a-regular" style={{ fontWeight: 400 }}>{t(AWARD_LI215)}</li>
        <li className="a-regular" style={{ fontWeight: 400 }}>{t(AWARD_LI216)}</li>
        <li className="a-regular" style={{ fontWeight: 400 }}>{t(AWARD_LI217)}</li>
        <li className="a-regular" style={{ fontWeight: 400 }}>{t(AWARD_LI218)}</li>
        <li className="a-regular" style={{ fontWeight: 400 }}>{t(AWARD_LI219)}</li>
        <li className="a-regular" style={{ fontWeight: 400 }}>{t(AWARD_LI220)}</li>
        <li className="a-regular" style={{ fontWeight: 400 }}>{t(AWARD_LI221)}</li>
        <li className="a-regular" style={{ fontWeight: 400 }}>{t(AWARD_LI222)}</li>
        <li className="a-regular" style={{ fontWeight: 400 }}>{t(AWARD_LI223)}</li>
        <li className="a-regular" style={{ fontWeight: 400 }}>{t(AWARD_LI224)}</li>
        <li className="a-regular" style={{ fontWeight: 400 }}>{t(AWARD_LI225)}</li>
        <li className="a-regular" style={{ fontWeight: 400 }}>{t(AWARD_LI226)}</li>
        <li className="a-regular" style={{ fontWeight: 400 }}>{t(AWARD_LI227)}</li>
        <li className="a-regular" style={{ fontWeight: 400 }}>{t(AWARD_LI228)}</li>
        <li className="a-regular" style={{ fontWeight: 400 }}>{t(AWARD_LI229)}</li>
        <li className="a-regular" style={{ fontWeight: 400 }}>{t(AWARD_LI230)}</li>
        <li className="a-regular" style={{ fontWeight: 400 }}>{t(AWARD_LI231)}</li>
        <li className="a-regular" style={{ fontWeight: 400 }}>{t(AWARD_LI232)}</li>
        <li className="a-regular" style={{ fontWeight: 400 }}>{t(AWARD_LI233)}</li>
        <li className="a-regular" style={{ fontWeight: 400 }}>{t(AWARD_LI234)}</li>
        <li className="a-regular" style={{ fontWeight: 400 }}>{t(AWARD_LI235)}</li>
        <li className="a-regular" style={{ fontWeight: 400 }}>{t(AWARD_LI236)}</li>
        <li className="a-regular" style={{ fontWeight: 400 }}>{t(AWARD_LI237)}</li>
        <li className="a-regular" style={{ fontWeight: 400 }}>{t(AWARD_LI238)}</li>
      </ul>
    </div>
  );
}

export default Awards;
